import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=0f5c800e&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=0f5c800e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5c800e",
  null
  
)

export default component.exports